import React from "react";

import { faCoinBlank, faTimer } from "@fortawesome/pro-regular-svg-icons";

import { Pill } from "src/design-system/Pill";
import { formatDuration } from "src/utils/numbers";

export const formatTokenCount = (count: number): string =>
  new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 1,
  })
    .format(count)
    .toLowerCase();

/**
 * Formats a USD cost value with appropriate precision.
 * For costs >= $0.01, shows 2 decimal places (e.g. "$1.23").
 * For smaller non-zero costs, shows up to 4 decimal places (e.g. "$0.0012").
 */
export const formatCost = (cost: number): string => {
  if (cost === 0) return "$0.00";
  if (cost >= 0.01) return `$${cost.toFixed(2)}`;
  return `$${cost.toFixed(4)}`;
};

export const DurationPill: React.FC<{ durationMs: number }> = ({
  durationMs,
}) => (
  <Pill size="sm" variant="gray">
    <Pill.Icon icon={faTimer} />
    <Pill.Text>{formatDuration(durationMs)}</Pill.Text>
  </Pill>
);

export const TokensPill: React.FC<{ count: number }> = ({ count }) => (
  <Pill size="sm" variant="gray">
    <Pill.Icon icon={faCoinBlank} />
    <Pill.Text>{formatTokenCount(count)}</Pill.Text>
  </Pill>
);
